import React, { useState } from 'react';
import { FiMail, FiArrowLeft, FiCheckCircle, FiSend, FiRefreshCw, FiLock } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import { userService } from '../../services/api';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Attempting to send reset email to:", email);
    setError('');
    setLoading(true);

    try {
      // Dynamic Reset URL: Ensuring the email link points back to this site
      const resetUrl = `${window.location.origin}/reset-password`;
      console.log("EliteDebug: Sending payload ->", { email, resetUrl });
      
      const response = await userService.forgotPassword(email, resetUrl);
      
      // SUPER DEBUG: Checking every detail from the server
      console.log("EliteDebug: FULL SERVER RESPONSE ->", JSON.stringify(response, null, 2));
      
      setSuccess(true);
    } catch (err) {
      console.error("API Error caught in ForgotPassword:", err);
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-overlay"></div>
      
      <div className="forgot-password-container">
        <Link to="/" className="back-to-home">
          <FiArrowLeft /> Back to Home
        </Link>

        <div className="forgot-password-card">
          {!success ? (
            <>
              <div className="forgot-password-header">
                <div className="header-icon-wrapper">
                  <FiLock className="header-icon" />
                </div>
                <h2>Forgot Password?</h2>
                <p>Enter your email address and we'll send you a secure link to reset your password.</p>
              </div>

              {error && <div className="error-message">{error}</div>}

              <form onSubmit={handleSubmit} className="forgot-password-form">
                <div className="input-field">
                  <label>Email Address</label>
                  <div className="input-wrapper">
                    <FiMail className="input-icon" />
                    <input
                      type="email"
                      placeholder="e.g. name@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <button type="submit" className={`submit-btn ${loading ? 'loading' : ''}`} disabled={loading}>
                  {loading ? (
                    <div className="spinner"></div>
                  ) : (
                    <>
                      Send Reset Link <FiSend />
                    </>
                  )}
                </button>
              </form>
            </>
          ) : (
            <div className="success-state">
              <div className="success-icon-wrapper">
                <FiCheckCircle className="success-icon" />
              </div>
              <h2>Check Your Email</h2>
              <p>
                We've sent a password reset link to <strong>{email}</strong>. 
                Please check your inbox and follow the instructions.
              </p>
              <button onClick={() => navigate('/')} className="return-btn">
                Return to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

